import React, { Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';
import Loading from '@/shared/components/Loading';
import MainWrapper from '../MainWrapper';
import ProtectedRoute from '../ProtectedRoute';
import PublicRoute from '../PublicRoute';
import {
  AccessDeniedPage,
  NotFoundPage,
  protectedRoutes,
  publicRoutes,
} from './routes';

const renderRoute = (RouteComponent, route) => {
  const Page = route.component;

  return (
    <RouteComponent
      key={route.path}
      allowedRoles={route.allowedRoles}
      exact={route.exact}
      path={route.path}
      requiredPermissions={route.requiredPermissions}
    >
      <Page />
    </RouteComponent>
  );
};

const Router = () => (
  <MainWrapper>
    <main>
      <Suspense fallback={<Loading loading />}>
        <Switch>
          {publicRoutes.map(route => renderRoute(PublicRoute, route))}
          {protectedRoutes.map(route => renderRoute(ProtectedRoute, route))}
          <Route exact path="/forbidden" component={AccessDeniedPage} />
          <Route path="*" component={NotFoundPage} />
        </Switch>
      </Suspense>
    </main>
  </MainWrapper>
);

export default Router;
